/* USER VIEWS */
import Vue from 'vue'
import NotificationCount from '../components/notifications/notification-count.vue'
import MenuAvatar from '../components/users/menu-avatar.vue'

/** USER PROFILE SPLIT */
export const accountCodeSplit = () => {
  Vue.component('profile-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/profile-form.vue'),
  )

  Vue.component('blender-register-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/blender-register-form.vue'),
  )

  Vue.component('edit-login-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/edit-login-form.vue'),
  )

  Vue.component('login-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/login-form.vue'),
  )

  Vue.component('forgot-password-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/forgot-password-form.vue'),
  )

  Vue.component('social-login-buttons', () =>
    import(/* webpackChunkName: "user" */ '../components/users/social-login-buttons.vue'),
  )

  Vue.component('add-blender-auth-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/add-blender-auth-form.vue'),
  )

  Vue.component('redeem-gift-code', () =>
    import(/* webpackChunkName: "user" */ '../components/users/redeem-gift-code.vue'),
  )

  Vue.component('delete-account-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/delete-account-form.vue'),
  )

  Vue.component('export-data-form', () =>
    import(/* webpackChunkName: "user" */ '../components/users/export-data-form.vue'),
  )

  /* CART */
  Vue.component('gift-message-form', () =>
    import(/* webpackChunkName: "user" */ '../components/cart/gift-message-form.vue'),
  )

  Vue.component('cart-coupon-code-form', () =>
    import(/* webpackChunkName: "user" */ '../components/cart/cart-coupon-code-form.vue'),
  )

  Vue.component('checkout-button', () =>
    import(/* webpackChunkName: "user" */ '../components/cart/checkout-button.vue'),
  )

  Vue.component('checkout-payment-form', () =>
    import(/* webpackChunkName: "user" */ '../components/cart/checkout-payment-form.vue'),
  )

  Vue.component('resend-gift-message', () =>
    import(/* webpackChunkName: "user" */ '../components/cart/resend-gift-message.vue'),
  )

  /* ACHIEVEMENT */
  Vue.component('achievement', () =>
    import(/* webpackChunkName: "user" */ '../components/achievements/achievement.vue'),
  )

  /* NOTIFICATION */
  // Only used for FB Admin preview
  Vue.component('notification', () =>
    import(/* webpackChunkName: "user" */ '../components/notifications/notification.vue'),
  )

  /* DASHBOARD */
  Vue.component('dashboard-carousel', () =>
    import(/* webpackChunkName: "user" */ '../components/carousels/dashboard-carousel.vue'),
  )

  Vue.component('popular-discussions-panel', () =>
    import(
      /* webpackChunkName: "user" */ '../components/discussions/popular-discussions-panel.vue'
    ),
  )

  // used on every page so not chunked
  Vue.component('notification-count', NotificationCount)
  Vue.component('menu-avatar', MenuAvatar)
}

export default accountCodeSplit
